import { render, staticRenderFns } from "./ExpenseAllocationCard.vue?vue&type=template&id=237b5e3f&"
import script from "./ExpenseAllocationCard.vue?vue&type=script&lang=js&"
export * from "./ExpenseAllocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports